import React from "react";
import '../index.css';

function Exp(){
    return(
        <>
        <div className="heroic">
            <h1>2 YEARS OF <span>EXPERIENCE</span></h1><br />
        </div>
        </>
    );
}

export default Exp;